/**
 * Created by Udara Prabath
 * Date: 11/4/2020
 * Using: IntelliJ IDEA
 */
import React from "react";
import './myLessons.scss'
import Header from "../../../components/Header/Header";
import {Container} from "reactstrap";
import {lang, language} from "../../../const/language";
import * as lessonService from "../../../services/lessons";
import * as commonFunc from "../../../utils/commonFunc";
import * as actionSpinnerCreator from "../../../store/domain/spinner/action";
import {connect} from "react-redux";
import NotFound from "../../../components/NotFound/NotFound";
import LessonItem from "../../../components/LessonItem/LessonItemPurchase";
import CardsFooter from "../../../components/Modals/Footers/CardsFooter";

class MyLessons extends React.Component{

    state = {
        lessons: []
    }

    componentDidMount() {
        document.documentElement.scrollTop = 0;
        document.scrollingElement.scrollTop = 0;
        this.refs.main.scrollTop = 0;
        this.getAllEnrolledLessons();
    }

    getAllEnrolledLessons = async () => {

        this.props.spinnerHandler({isSpin: true, type: 15});
        await lessonService.getEnrollLessons()
            .then(response => {
                this.props.spinnerHandler(false);
                if (response.success) {
                    this.setState({
                        lessons: response.body
                    })
                }else{
                    commonFunc.notifyMessage(response.message, response.status);
                }
            })
    };

    render() {
        return(
            <div>
                <Header active={2}/>
                <main ref="main" className={"myLessons"}>
                    <section>
                        <Container>
                            <div>
                                <h3 className={"teach-black-text head-topic align-center"}>{language[lang].ListOfJoinedLessons}</h3>
                            </div>
                            <div>
                                {
                                    this.state.lessons.length === 0 && <NotFound/>
                                }
                                <LessonItem lessons={this.state.lessons}/>
                            </div>
                        </Container>
                    </section>
                </main>
                <CardsFooter/>
            </div>
        )
    }
}

const mapStateToProps = (state) => ({
});
const mapDispatchToProps = (dispatch) => ({
    spinnerHandler: data => dispatch(actionSpinnerCreator.spinnerHandler(data)),
});
export default connect(mapStateToProps, mapDispatchToProps)(MyLessons);